/**
 * The HTML panel type and the settings it draws from.
 */

const html = {
  names: [{ id: 'html', label: 'HTML', phrase: 'a custom HTML panel', guide: 'html.md', advanced: false, toolSummary: 'free-form custom-HTML panel body for bespoke visualizations the standard types cannot express', promptSummary: 'a free-form custom-HTML body the transform builds — for bespoke visualizations like heatmaps and scorecards the standard types cannot express' }],
  block: 'html',
  fields: { key: { kind: 'string', required: true } },
  /* Keyed off the type rather than the block: an html panel names its body column even before one
     is chosen, because the default is what it will read. */
  stateSummary: ({ block, type }) => (type === 'html' ? `html: body key ${block.key || 'html'}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['key'],
    description: 'HTML panel mapping (displayType "html"): the FIRST data row\'s value at this key is the ENTIRE panel body — one markup document the transform builds from the data. A column named "html" auto-assigns when this is omitted. MANDATORY before authoring: knowledge_read immutable/analytics/panel-types/html.md — it routes to the closed custom-HTML rule set; markup outside those rules fails the cook.',
    properties: {
      key: { type: 'string', description: "Column holding the panel's HTML document." }
    }
  }
};

export default html;
